import { createHead } from '@unhead/vue'
import { ViteSSG } from 'vite-ssg'
import App from './App.vue'
import Home from './pages/Home.vue'
import ClientOnly from './components/ClientOnly.vue'
import './styles/base.scss'

export const createApp = ViteSSG(
  App,
  { routes: [{ path: '/', component: Home }] },
  async ({ app, isClient }) => {
    app.use(createHead())
    app.component('ClientOnly', ClientOnly)

    if (isClient) {
      const { default: MTD } = await import('@ss/mtd-vue3')
      await import('@ss/mtd-vue3/lib/theme-chalk/index.css')
      app.use(MTD)
    }
  }
)
